module.exports = __webpack_public_path__ + "dd93d3bd50efbb4be735e1ad51ea53e6.glb";